import {parseShortTextProjects} from "@/app/[locale]/common/utils/functions/parseShortTextProjects/parseShortTextProjects";
import {TAllProjectItem, TAllProjectItemServerResponse, TShortText} from "@/app/[locale]/projects/types";

export const extractDescriptionProjectFromJSON = (projects: TAllProjectItemServerResponse[]): TAllProjectItem[] => {
    return projects.map((project: TAllProjectItemServerResponse) => {
        const shortText: TShortText[] = parseShortTextProjects(project.shortText);
        try {
            return {
                ...project, shortText: project.shortText ? shortText : null,
            };
        } catch (err) {
            console.log(err);
            return { ...project, shortText: null };
        }
    })
};